import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-delete-from-portafoglio-confirmation-dialog',
  templateUrl: './delete-from-portafoglio-confirmation-dialog.component.html',
  styleUrls: []
})
export class DeleteFromPortafoglioConfirmationDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<string>,
    @Inject(MAT_DIALOG_DATA) public data: string
  ) {}

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }

}
